var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQRcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 8.85V7C21 4.79086 19.2091 3 17 3H15.15M21 15.15V17C21 19.2091 19.2091 21 17 21H15.15M8.85 21H7C4.79086 21 3 19.2091 3 17V15.15M3 8.85V7C3 4.79086 4.79086 3 7 3H8.85",
    stroke: "#1C1C20",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12L2 12",
    stroke: "#1C1C20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 9C6 7.34315 7.34315 6 9 6H15C16.6569 6 18 7.34315 18 9V10.25L6 10.25V9ZM6 11.75V12.25L18 12.25V11.75L6 11.75ZM6 13.75L18 13.75V15C18 16.6569 16.6569 18 15 18H9C7.34315 18 6 16.6569 6 15V13.75Z",
    fill: "#1C1C20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQRcode);
export default __webpack_public_path__ + "static/media/QRcode.e1e47b4640798b18a7fd9e01334d7bd2.svg";
export { ForwardRef as ReactComponent };